import React from "react";
import { Row, Col, Typography } from "antd";
const { Text, Title } = Typography;

export default function BuyerDetails({ text }) {
  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <Title level={5} style={{ margin: 0 }}>
              {text?.name}
            </Title>
          </Col>
        </Row>
        <Row>
          <Col>
            <Text type="secondary">{text?.email}</Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
